module.exports = __webpack_public_path__ + "img/current-badge-prospect.f650b00e.svg";